import { useUnviewedCoins } from '@/hooks/useAchievements'

/** Brian's coin dot on the initials: a coin celebrated and not yet looked at
 *  in Achievements (badge spec §6: it persists until Achievements is opened). */
export function useUnplacedCoins(): boolean {
  return useUnviewedCoins().length > 0
}
